import * as Yup from 'yup';

import { timeBoundValuesSectionSchema } from '../Sections/TimeBoundValuesSection/utils/timeBoundValuesSectionSchema';

import { defaultSectionSchema } from '../Sections/DefaultSection';
import { employeePortalSectionSchema } from '../Sections/EmployeePortalSection';

export const schema = Yup.object().shape({
  ...defaultSectionSchema.fields,
  ...timeBoundValuesSectionSchema.fields,
  ...employeePortalSectionSchema.fields
});
